// extracted by mini-css-extract-plugin
export default {"shell":"AdminLayout_shell__hAeO4","content":"AdminLayout_content__zmAiy","main":"AdminLayout_main__58g8J","backdrop":"AdminLayout_backdrop__QcUkc"};